import { useState } from "react";
import getUrl from "../../tools/get-domain";

export default function BlackScholesCalculator() {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const blackscholesFields = [
        {
            id: 1,
            title: "نوع اختیار",
            type: "select",
            values: ["Call", "Put"],
            name: "option_type",
        },
        {
            id: 2,
            title: "قیمت اعمال",
            type: "text",
            values: null,
            name: "strike_price",
        },
        {
            id: 3,
            title: "مانده تاسررسید",
            type: "text",
            values: null,
            name: "mature",
        },
        {
            id: 4,
            title: "نوسان پذیری (درصد)",
            type: "text",
            values: null,
            name: "volatility",
        },
        {
            id: 5,
            title: "نرخ بهره (درصد)",
            type: "text",
            values: null,
            name: "interest_rate",
        },
        {
            id: 6,
            title: "قیمت دارایی پایه",
            type: "text",
            values: null,
            name: "base_price",
        },
    ];

    const getCSRFToken = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name, value] = cookie.split("=");
            if (name === "csrftoken") {
                return value;
            }
        }
        return null;
    };

    const handleSubmitForm = async (event) => {
        event.preventDefault();

        setIsLoading(true);

        const form = new FormData(event.target);

        const parameters = Object.fromEntries(
            Array.from(form.entries()).map(([key, value]) => [
                key,
                key === "option_type"
                    ? value
                    : Number(value.replaceAll(",", "")),
            ])
        );

        const csrfToken = getCSRFToken();
        if (!csrfToken) {
            console.log("credentials not provided");
            return;
        }

        const response = await fetch(
            `${getUrl().REACT_APP_BLACLSCHOLES_ENDPOINT}`,
            {
                method: "POST",
                headers: {
                    "X-CSRFToken": csrfToken,
                },
                credentials: "include",
                body: JSON.stringify(parameters),
            }
        );

        const data = await response.json();

        setData(data["result"]);
        setIsLoading(false);
    };

    const inputChangeHandler = (e) => {
        const numericValue = e.target.value.replace(/[^0-9.]/g, "");
        const formattedValue = Number(numericValue).toLocaleString();
        e.target.value = formattedValue === "0" ? "" : formattedValue;
    };

    return (
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2">
            {/* Input */}
            <div className="md:tw-border-l md:tw-border-gray-200 md:tw-pl-3">
                <form method="post" onSubmit={handleSubmitForm}>
                    <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                        {blackscholesFields.map((field) =>
                            field.type === "text" ? (
                                <div
                                    className="tw-flex tw-flex-col"
                                    key={field.id}
                                >
                                    <label
                                        htmlFor={field.title}
                                        className="tw-block tw-text-sm tw-font-semibold tw-text-gray-800 tw-mb-1"
                                        style={{
                                            textShadow:
                                                "1px 1px 2px rgba(0, 0, 0, 0.1)",
                                        }}
                                    >
                                        {field.title}
                                    </label>
                                    <input
                                        onChange={inputChangeHandler}
                                        id={field.title}
                                        dir="ltr"
                                        type="text"
                                        name={field.name}
                                        placeholder={`${field.title} را وارد کن`}
                                        className="tw-px-4 tw-w-full tw-rounded-lg tw-border tw-border-gray-300 tw-bg-gray-100 tw-h-12 tw-text-gray-900 tw-text-sm tw-font-medium focus:tw-outline-none focus:tw-border-blue-400 focus:tw-shadow-[0_4px_15px_rgba(0,0,0,0.2)]"
                                        style={{
                                            background:
                                                "linear-gradient(145deg, #ffffff, #e6e6e6)",
                                            boxShadow:
                                                "4px 4px 6px #d1d2d3, -4px -4px 6px #ffffff",
                                            transition: "all 0.3s ease-in-out",
                                        }}
                                        onFocus={(e) =>
                                            (e.target.style.boxShadow =
                                                "6px 6px 10px #d1d2d3, -6px -6px 10px #ffffff")
                                        }
                                        onBlur={(e) =>
                                            (e.target.style.boxShadow =
                                                "4px 4px 6px #d1d2d3, -4px -4px 6px #ffffff")
                                        }
                                    />
                                </div>
                            ) : field.type === "select" ? (
                                <div
                                    className="tw-flex tw-flex-col"
                                    key={field.id}
                                >
                                    <label
                                        htmlFor={field.title}
                                        className="tw-block tw-text-sm tw-font-semibold tw-text-gray-800 tw-mb-1"
                                        style={{
                                            textShadow:
                                                "1px 1px 2px rgba(0, 0, 0, 0.1)",
                                        }}
                                    >
                                        {field.title}
                                    </label>
                                    <select
                                        name={field.name}
                                        className="tw-px-4 tw-w-full tw-rounded-lg tw-border tw-border-gray-300 tw-bg-gray-100 tw-h-12 tw-text-gray-900 tw-text-sm tw-font-medium focus:tw-outline-none focus:tw-border-blue-400 focus:tw-shadow-[0_4px_15px_rgba(0,0,0,0.2)]"
                                        style={{
                                            background:
                                                "linear-gradient(145deg, #ffffff, #e6e6e6)",
                                            boxShadow:
                                                "4px 4px 6px #d1d2d3, -4px -4px 6px #ffffff",
                                            transition: "all 0.3s ease-in-out",
                                        }}
                                        onFocus={(e) =>
                                            (e.target.style.boxShadow =
                                                "6px 6px 10px #d1d2d3, -6px -6px 10px #ffffff")
                                        }
                                        onBlur={(e) =>
                                            (e.target.style.boxShadow =
                                                "4px 4px 6px #d1d2d3, -4px -4px 6px #ffffff")
                                        }
                                    >
                                        {field.values.map((item, index) => (
                                            <option key={index} value={item}>
                                                {item}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            ) : (
                                ""
                            )
                        )}
                    </div>

                    <div className="tw-flex tw-items-center tw-justify-end tw-mt-6 max-md:tw-mb-6">
                        <button
                            disabled={isLoading}
                            type="submit"
                            className="tw-px-4 tw-bg-gradient-to-r tw-from-cyan-500 tw-to-blue-500 tw-text-white tw-h-12 tw-rounded-lg"
                        >
                            {isLoading ? "منتظر بمانید" : "محاسبه"}
                        </button>
                    </div>
                </form>
            </div>
            <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                <div className="tw-flex tw-flex-col">
                    <label
                        htmlFor=""
                        className="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1"
                    >
                        قیمت بلک شولز
                    </label>
                    <input
                        dir="ltr"
                        type="text"
                        readOnly
                        disabled
                        className="tw-px-2 tw-w-full tw-rounded-xl tw-border tw-border-gray-300 tw-bg-gray-100 tw-h-12 tw-pr-3 tw-text-gray-900"
                        style={{
                            borderRadius: "8px",
                            background: "#f9fafb",
                            boxShadow:
                                "inset 5px 5px 1px #d1d2d3, inset -5px -5px 1px #ffffff",
                        }}
                        value={data !== null ? data : ""}
                    />
                </div>
            </div>
        </div>
    );
}
